<template>
  <b-container fluid class="">
    <b-container class="flex-container position-relative aux-top-45">
      <div class="box">
        <div class="aux-font-size-80">
          <!--HERE IS A BLACK ICON YOU DON'T SEE -->
          🚧
        </div>
        <br />
        <div>
          <h2 class="mb-5">{{ $t('global.404_500.title') }} 🙊</h2>
          <p class="text-muted pb-5">{{ $t('global.404_500.description') }}</p>

          <b-form-group class="text-center">
            <b-button variant="primary"
                      size="lg"
                      class="d-inline-flex align-items-center"
                      @click="$router.push($defaultRoute())"
            >
              {{ $t('global.next') }}
            </b-button>
          </b-form-group>
        </div>
      </div>
    </b-container>
  </b-container>
</template>

<script>
export default {
  name: '404',
}
</script>

<style scoped lang="scss">
.aux-top-45 {
  top: 45px;
}

.aux-font-size-80 {
  font-size: pxtorem(80);
}
.flex-container {
  display: flex; /* establish flex container */
  flex-direction: column; /* make main axis vertical */
  justify-content: center; /* center items vertically, in this case */
  align-items: center; /* center items horizontally, in this case */
  height: 98vh;
}

.box {
  margin: 5px;
  text-align: center; /* will center text in <p>, which is not a flex item */
}
</style>
